import React, { useState, useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import './CustomTile.css';

// Pamięć podręczna dla pobranych blobów/adresów URL obrazów
const imageCache = new Map();

function CustomTile({
                       imageUrl,
                       textLines = [],
                       backgroundColor = '#e8e4df',
                       showNumber = true,
                       number = '1',
                       numberColor = '#ff8c42',
                       useAuth = false,
                       tiny = false,
                       tileClassName = 'custom-tile',
                       imageContainerClassName = "custom-image-container",
                       imageClassName = "custom-image",
                    }) {
    const cachedUrl = imageUrl && typeof imageCache.get(imageUrl) === 'string'
        ? imageCache.get(imageUrl)
        : (!useAuth && imageUrl ? imageUrl : null);
    const [imageSrc, setImageSrc] = useState(cachedUrl);
    const [imageError, setImageError] = useState(false);
    const [isLoading, setIsLoading] = useState(!cachedUrl && !!imageUrl);

    // Pobierz token z Redux
    const accessToken = useSelector((state) => state.tokens.accessToken);

    useEffect(() => {
        let isMounted = true;

        if (!imageUrl) {
            setImageError(true);
            setIsLoading(false);
            return;
        }

        const cached = imageCache.get(imageUrl);
        if (typeof cached === 'string') {
            setImageSrc(cached);
            setImageError(false);
            setIsLoading(false);
            return;
        }

        if (!useAuth || !accessToken) {
            setImageSrc(imageUrl);
            setImageError(false);
            setIsLoading(false);
            return;
        }

        const loadImage = async () => {
            try {
                let fetchPromise = imageCache.get(imageUrl);
                if (!fetchPromise || typeof fetchPromise === 'string') {
                    fetchPromise = (async () => {
                        const response = await fetch(imageUrl, {
                            method: 'GET',
                            headers: {
                                'Authorization': `Bearer ${accessToken}`,
                            },
                            credentials: 'include',
                            mode: 'cors'
                        });

                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }

                        const blob = await response.blob();
                        const objUrl = URL.createObjectURL(blob);
                        imageCache.set(imageUrl, objUrl);
                        return objUrl;
                    })();
                    imageCache.set(imageUrl, fetchPromise);
                }

                const resolvedUrl = await fetchPromise;
                if (isMounted) {
                    setImageSrc(resolvedUrl);
                    setImageError(false);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error('Błąd ładowania obrazka:', error);
                imageCache.delete(imageUrl);
                if (isMounted) {
                    setImageError(true);
                    setIsLoading(false);
                }
            }
        };

        loadImage();

        return () => {
            isMounted = false;
        };
    }, [imageUrl, accessToken, useAuth]);

    return (
        <div className={tileClassName} style={{ backgroundColor }}>
            <div className={"custom-tile-content"}>
                <div className={imageContainerClassName}>
                    {isLoading ? (
                        <div className="custom-image-placeholder">
                            <span>Ładowanie...</span>
                        </div>
                    ) : imageError ? (
                        <div className="custom-image-placeholder">
                            <span>Brak obrazka</span>
                        </div>
                    ) : (
                        <img
                            src={imageSrc}
                            alt={textLines[0] || 'Event'}
                            className={imageClassName}
                            onError={() => {
                                console.error('Błąd ładowania obrazka (img tag)');
                                setImageError(true);
                            }}
                        />
                    )}
                </div>

                {showNumber && (
                    <div
                        className={textLines.length  < 2 ? "custom-number custom-font-65" : "custom-number"}
                        style={{ color: numberColor }}
                    >
                        {number}
                    </div>
                )}

                <div className="custom-info">

                    {!tiny && textLines.map((line, index) => (
                        <div
                            key={index}
                            className={`custom-text custom-text-${index + 1}`}
                        >
                            {line}
                        </div>
                    ))}
                    {tiny &&
                        <div
                            key={1}
                            className={`custom-text custom-text-1`}
                        >
                            {textLines.values().next().value}
                        </div>}
                </div>
            </div>
        </div>
    );
}

export default memo(CustomTile);